// Country + state location fields for tearsheet create (reuses LocationSelector).
import { LocationSelector } from '@/components/domain';
import type { LocationGroup } from '@/types';

export function TearsheetLocationFields({
  value,
  onChange,
  error,
  id,
  optional = false,
}: {
  value: LocationGroup[];
  onChange: (rows: LocationGroup[]) => void;
  error?: string;
  id?: string;
  /** When true, country is not required (user may skip). */
  optional?: boolean;
}) {
  return (
    <div className="tearsheet-location-fields" data-testid="tearsheet-custom-location" id={id}>
      <span className="tearsheet-location-label">
        Location{optional ? ' (optional)' : null}
        {!optional ? <span className="text-danger"> *</span> : null}
      </span>
      <p className="small text-muted mb-2">
        Country and state help us find the right company when names overlap. State is optional —
        country alone is fine.
      </p>
      <LocationSelector value={value} onChange={onChange} countryStateOnly />
      {error ? (
        <p className="small text-danger mb-0" data-testid="tearsheet-location-error">
          {error}
        </p>
      ) : null}
    </div>
  );
}
